import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-confirm-bottom-sheet',
  templateUrl: './confirm-bottom-sheet.component.html',
  styleUrls: ['./confirm-bottom-sheet.component.css'],
  imports: [ 
    CommonModule,
    MatBottomSheetModule
   ]
})
export class ConfirmBottomSheetComponent {

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ConfirmBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { sheetTitle: string, sheetText: string, buttonText: string, sheetHtml: string }
  ) {}

  handleConfirm(): void {
    this.bottomSheetRef.dismiss(true);
  }
}
